import 'react';
import { useTheme, jsx } from '@emotion/react';
import '@babel/runtime/helpers/extends';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';
import CrossIcon from '../../icons/icons/crossIcon.js';
import Style from './style.js';
import { isDefined } from '../../utils/isDefined/index.js';

var getCalloutStyles = (theme, type) => {
  // Default values if no type provided
  var backgroundColor = theme.COLORS.infoLight;
  var textColor = theme.COLORS.primary;

  if (type === 'success') {
    backgroundColor = theme.COLORS.successLight;
    textColor = theme.COLORS.success;
  } else if (type === 'error') {
    backgroundColor = theme.COLORS.errorLight;
    textColor = theme.COLORS.error;
  }

  return {
    backgroundColor,
    textColor
  };
};
/**
 * Callouts should be used to provide valuable information or additional context on a page. One of the best examples of a callout is for product recommendations.
 *
 * `Callout` will cover the entirety of the container that holds it. You may optionally wrap it with `Callout.Container` which will set the `max-width` to `327px`.
 *
 * If you use a glyph as callout icon the recommended dimesions are 48x48 pixels (which is the default for Glyphs).
 */


var Callout = _ref => {
  var {
    children,
    icon,
    onClose,
    type
  } = _ref;
  var theme = useTheme();
  var {
    backgroundColor,
    textColor
  } = getCalloutStyles(theme, type);
  return jsx(Style.CalloutContainer, {
    backgroundColor: backgroundColor,
    displayCloseIcon: !!onClose
  }, !!onClose && jsx(Style.CrossIconContainer, {
    "aria-label": "Close callout",
    onClick: onClose
  }, jsx(CrossIcon, null)), jsx(Style.Text, {
    textColor: textColor
  }, children), isDefined(icon) && icon !== false && jsx(Style.Icon, {
    iconColor: textColor
  }, icon));
};
Callout.Container = Style.ParentContainer;

export { Callout };
